/**
 * ErrorBoundary — catches React render errors and shows a branded recovery screen.
 */

import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            background: 'var(--md-sys-color-surface)',
            color: 'var(--md-sys-color-on-surface)',
            gap: '24px',
            padding: '32px',
            textAlign: 'center',
          }}
        >
          <span
            style={{
              fontSize: '2.5rem',
              fontWeight: 700,
              color: 'var(--md-sys-color-primary)',
              letterSpacing: '-0.02em',
            }}
          >
            eduksy.
          </span>
          <p style={{ fontSize: '1.25rem', maxWidth: '400px', lineHeight: 1.5 }}>
            Something went wrong. We hit an unexpected error.
          </p>
          <md-filled-button
            onClick={() => {
              window.location.href = '/';
            }}
          >
            <span className="material-symbols-outlined" slot="icon">
              home
            </span>
            Restart Demo
          </md-filled-button>
        </div>
      );
    }

    return this.props.children;
  }
}
